import { initTeamQuotesCarousel } from '@components/sliders/sliders'

document.addEventListener('DOMContentLoaded', () => {
  initTeamQuotesCarousel()
}, { once: true })
